<mat-card
  class="test"
  [formGroup]="form()">
  <div class="middlecards">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Miscellaneous:</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list
          role="list"
          class="generalTableStyle">
          @for (finalList of finalLists; track finalList) {
          <div class="row item">
            <div class="col-md-4 col-sm-12">
              {{ finalList.text }}
            </div>
            <div class="col-md-4 col-sm-12">
              {{ finalList.value1 }}
            </div>
            <div class="col-md-4 col-sm-12">
              {{ finalList.value2 }}
            </div>
          </div>
          }
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="middlecards">
    <mat-form-field>
      <input
        formControlName="shortText1"
        matInput
        placeholder="Short text 1" />
    </mat-form-field>
    <mat-form-field>
      <input
        formControlName="shortText2"
        matInput
        placeholder="Short text 2" />
    </mat-form-field>
    <mat-form-field>
      <input
        formControlName="adjournedReason"
        matInput
        placeholder="Short Text Adjourned" />
    </mat-form-field>
    <mat-form-field>
      <input
        value="{{ form().get('prolongationDeadline')?.value }}"
        matInput
        placeholder="Prolongation, Date"
        disabled />
      <mat-datepicker-toggle
        matSuffix
        [for]="dateJoined"></mat-datepicker-toggle>
      <mat-datepicker #dateJoined></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <input
        value="{{ form().get('other_prolongations')?.value }}"
        matInput
        placeholder="History"
        disabled />
    </mat-form-field>
  </div>
  <div class="middlecards">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Roles:</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list
          role="list"
          class="generalTableStyle">
          <div class="row item">
            <div class="col-md-4">Auditor</div>
            <div class="col-md-4">{{ recommendations().authorsAuditor }}</div>
            <div class="col-md-4">Role for Auditor</div>
          </div>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="middlecards">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Document access is given to:</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list
          role="list"
          class="generalTableStyle">
          @for (finalSmallList of finalSmallLists; track finalSmallList) {
          <div class="row item">
            <div class="col-md-4 col-sm-12">
              {{ finalSmallList.text }}
            </div>
            <div class="col-md-4 col-sm-12">
              {{ finalSmallList.value1 }}
            </div>
            <div class="col-md-4 col-sm-12">
              {{ finalSmallList.value2 }}
            </div>
          </div>
          }
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="middlecards">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Notes Names</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list
          role="list"
          class="generalTableStyle">
          <div class="row item">
            <div class="col-md-4 col-sm-12">Assessment Coordinator</div>
            <div class="col-md-8 col-sm-12">
              {{ recommendations().assessmentCoordinator | userName: recommendations().assessmentCoordinatorName | async }}
              {{ recommendations().assessmentCoordinator | azureIdStatus | async }}
            </div>
          </div>
          <div class="row item">
            <div class="col-md-4 col-sm-12">Legal Unit Responsibles</div>
            <div class="col-md-8 col-sm-12">
              @for (responsible of recommendations().legalUnitResponsibles; track responsible; let i = $index; let isLast = $last) {
              {{ responsible | userName: (recommendations().legalUnitResponsiblesNames || [])[i] | async }} {{ responsible | azureIdStatus | async }}@if (!isLast) {, } }
            </div>
          </div>
          <div class="row item">
            <div class="col-md-4 col-sm-12">Other Responsibles</div>
            <div class="col-md-8 col-sm-12">
              @for (responsible of recommendations().otherResponsibles; track responsible; let i = $index; let isLast = $last) {
              {{ responsible | userName: (recommendations().otherResponsiblesNames || [])[i] | async }} {{ responsible | azureIdStatus | async }}@if (!isLast) {, } }
            </div>
          </div>
        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
</mat-card>
